import { Extra } from "features/ProductReel/types";
import React from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { DefaultText } from "theme/GlobalElements";
import { colors } from "theme/Theme";

interface ProductDescriptionProps {
  extras: Extra[];
}

const ProductDescription: React.FC<ProductDescriptionProps> = ({ extras }) => {
  return (
    <ProductDescriptionContainer>
      {extras.map((item, idx) => {
        return (
          <ItemContainer key={idx} className="item">
            <ItemImageContainer>
              <ItemImage
                src={`data:${item.image.contentType};base64,${item.image.image}`}
              />
            </ItemImageContainer>
            <TitleContentContainer>
              <ItemTitle className="text-body">{item.title}</ItemTitle>
              <ItemContent className="text-sm">{item.text}</ItemContent>
            </TitleContentContainer>
          </ItemContainer>
        );
      })}
    </ProductDescriptionContainer>
  );
};

const ProductDescriptionContainer = styled.div`
  background-color: white;
  display: flex;
  flex-flow: column;
  padding: 10px;
  border: 1px solid ${colors.gray};
`;
ProductDescriptionContainer.displayName = "ProductDescriptionContainer";

const ItemContainer = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;

  & + & {
    margin-top: 20px;
  }

  @media only screen and (${device.tablet}) {
    flex-flow: row nowrap;
    justify-content: space-between;
  }
`;
ItemContainer.displayName = "ItemContainer";

const ItemImageContainer = styled.div`
  & + & {
    margin-top: 12px;
  }

  @media only screen and (${device.tablet}) {
    width: 180px;
    height: 135px;
  }

  @media only screen and (${device.laptopL}) {
    width: 280px;
    height: 210px;
  }
`;

const ItemImage = styled.img`
  width: 100%;
  aspect-ration: 4/3;
`;

const TitleContentContainer = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;

  @media only screen and (${device.tablet}) {
    margin-left: 10px;
  }
`;
TitleContentContainer.displayName = "TitleContentContainer";

const ItemTitle = styled(DefaultText)`
  margin: 10px 0;
  font-weight: 700;
`;
ItemTitle.displayName = "ItemTitle";

const ItemContent = styled(DefaultText)`
  font-weight: 300;
  margin: 0;
`;
ItemContent.displayName = "ItemContent";

export default ProductDescription;
